import { Component, Input, OnInit } from '@angular/core';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-contact-support',
  templateUrl: './contact-support.component.html',
  styleUrls: ['./contact-support.component.scss'],
})
export class ContactSupportComponent implements OnInit {

  @Input() centerText: boolean;
  @Input() inlineText: boolean;
  @Input() lowercase: boolean;

  public contactSupportURL: string;

  constructor(
    private config: ConfigService,
    private appLinksService: AppLinksService
  ) { }

  ngOnInit(): void {
    this.contactSupportURL = this.config.getConfig().FEATURE_CUSTOMER_SUPPORT_URL;
  }

  public onContactSupport() {
    return this.appLinksService.openExternalPage(this.contactSupportURL);
  }

}
